module.exports = __webpack_public_path__ + "img/pic_ren.5dcbfe14.png";